import React from 'react';

import { Section } from '@/components/global/Section';
import { Title } from '@/components/global/Title';
import { Slider } from '@/components/Template/Template7/Slider';

import { TRecommendation } from '@/services/requests/Recommendation/types/template7';

import { clearHtmlTags } from '@/helpers/HtmlHelper/clearHtmlTags';

type TTemplateVitrine7Props = {
  data: TRecommendation[];
};

const TemplateVitrine7 = ({ data }: TTemplateVitrine7Props) => {
  const template = data[0];

  const title = clearHtmlTags(template.title);

  return (
    <Section className="vitrine-template7" data={data}>
      <div className="vitrine-template7__container">
        <Title data={{ title }} template="7" />
        <Slider data={template} />
      </div>
    </Section>
  );
};

export default TemplateVitrine7;
